module.exports = __webpack_public_path__ + "img/Canada150_Logo_MainPrincipal_RedRouge_RGB.57944666.png";